const size16 = {
  'add-user': '\ue900',
  'advanced-settings': '\ue9ea',
  'alarm-bell': '\ue901',
  'align-bottom': '\ue902',
  'align-horizontal-center': '\ue903',
  'align-left': '\ue904',
  'align-right': '\ue905',
  'align-top': '\ue906',
  'align-vertical-center': '\ue907',
  align: '\ue9eb',
  'analyze-document': '\ue908',
  anchor: '\ue909',
  'audio-off': '\ue90a',
  'audio-on': '\ue90b',
  background: '\ue90c',
  'bar-chart': '\ue90d',
  'battery-charging': '\ue90e',
  'battery-empty': '\ue90f',
  'battery-full': '\ue910',
  'battery-half': '\ue911',
  'battery-high': '\ue912',
  'battery-low': '\ue913',
  bearing: '\uea1d',
  'binary-data': '\ue914',
  bluetooth: '\ue915',
  bookmark: '\uf101',
  boolean: '\ue916',
  briefcase: '\ue917',
  'bring-to-front': '\ue918',
  broadcast: '\ue919',
  calculator: '\ue91a',
  calendar: '\ue91b',
  calibration: '\ue9ed',
  'call-outline': '\ue9fd',
  call: '\ue91c',
  camera: '\ue91d',
  'caret-down': '\uea08',
  'caret-left': '\uea1c',
  'caret-right': '\uea30',
  'caret-up': '\uea34',
  cart: '\ue91e',
  'certificate-document-1': '\ue91f',
  'certificate-document-2': '\ue920',
  chat: '\ue921',
  'check-mark-circle-1': '\ue923',
  'check-mark-circle-2': '\ue924',
  'check-mark-light': '\uea3a',
  'check-mark': '\ue922',
  'close-light': '\uea35',
  close: '\ue925',
  cloud: '\uea1e',
  comment: '\ue926',
  computer: '\ue927',
  connect: '\ue928',
  connection: '\ue9ee',
  'controller-cabinet': '\ue929',
  'controls-and-settings': '\ue92a',
  copy: '\ue92b',
  'create-backup': '\ue9f0',
  cut: '\ue92c',
  dashboard: '\ue92d',
  'data-editor': '\ue9f1',
  'database-new': '\ue92f',
  database: '\ue92e',
  decimal: '\ue930',
  'delete-drives': '\uea1f',
  devices: '\ue931',
  disconnect: '\ue932',
  distribution: '\ue933',
  'document-excel': '\ue9f8',
  'document-pdf': '\ue9f9',
  'document-word': '\ue9fa',
  document: '\ue934',
  dollar: '\ue935',
  'double-down': '\ue936',
  'double-left': '\ue937',
  'double-right': '\ue938',
  'double-up': '\ue939',
  'down-arrow': '\ue93b',
  down: '\ue93a',
  'download-from-cloud': '\uea20',
  download: '\ue93c',
  'drive-connected': '\uea21',
  drive: '\ue93d',
  'drives-error': '\uea22',
  edge: '\uf103',
  edit: '\ue93e',
  'end-call': '\ue93f',
  envelope: '\ue940',
  'error-circle-1': '\ue941',
  'error-circle-2': '\ue942',
  euro: '\ue943',
  event: '\ue944',
  execution: '\ue9f2',
  export: '\ue945',
  factory: '\ue946',
  fieldbus: '\uea23',
  filter: '\ue947',
  'folder-new': '\ue949',
  'folder-open': '\ue94a',
  folder: '\ue948',
  forward: '\ue94b',
  fullscreen: '\ue94c',
  gauge: '\ue94d',
  gbp: '\ue94e',
  generator: '\uea24',
  globe: '\ue94f',
  group: '\ue950',
  'hardware-devices': '\ue9f3',
  'help-circle-1': '\ue951',
  'help-circle-2': '\ue952',
  hide: '\ue953',
  hierarchy: '\uf104',
  history: '\ue954',
  home: '\ue955',
  'hour-glass': '\ue956',
  image: '\ue957',
  import: '\ue958',
  'information-circle-1': '\ue959',
  'information-circle-2': '\ue95a',
  'io-devices': '\ue9f4',
  'io-signals': '\uea10',
  'jog-linear': '\ue9f7',
  'jog-planar': '\uea01',
  'jog-reorient': '\uea07',
  joystick: '\ue9f5',
  key: '\ue95b',
  label: '\ue95c',
  'lead-through': '\ue9f6',
  'left-arrow': '\ue95e',
  left: '\ue95d',
  level: '\ue95f',
  'light-bulb': '\ue960',
  link: '\ue961',
  'list-2': '\uf105',
  list: '\ue962',
  'location-outline': '\uea25',
  location: '\ue963',
  'lock-closed': '\ue964',
  'lock-open': '\ue965',
  'log-in': '\ue966',
  'log-out': '\ue967',
  magnet: '\ue968',
  'make-same-height': '\ue969',
  'make-same-size': '\ue96a',
  'make-same-width': '\ue96b',
  map: '\ue96c',
  matrix: '\ue96d',
  maximize: '\ue96e',
  'maximum-value': '\uea26',
  'menu-narrow': '\ue970',
  menu: '\ue96f',
  'microphone-off': '\ue972',
  microphone: '\ue971',
  minimize: '\ue973',
  'minimum-value': '\uea27',
  'minus-in-circle': '\ue975',
  minus: '\ue974',
  'missed-call': '\ue976',
  'modify-rapid-position': '\ue9fb',
  moon: '\ue977',
  more: '\ue978',
  motor: '\ue979',
  'network-signal-strength-level-1': '\uea0d',
  'network-signal-strength-level-2': '\uea0e',
  'network-signal-strength-level-3': '\uea0f',
  'network-status-1': '\ue9fe',
  'network-status-2': '\ue9ff',
  'network-status': '\ue9ef',
  network: '\ue97a',
  'new-document': '\ue97b',
  'not-allowed': '\uea28',
  'numbered-list': '\uea3b',
  numericals: '\ue97c',
  'object-container-1': '\ue97e',
  'object-container-2': '\ue97f',
  object: '\ue97d',
  'open-in-new-window': '\ue980',
  panel: '\ue981',
  'paper-clip': '\ue982',
  paste: '\ue983',
  pause: '\ue984',
  payload: '\uea00',
  'pie-chart': '\ue985',
  pin: '\ue986',
  play: '\ue987',
  plugin: '\ue988',
  'plus-in-circle': '\ue98a',
  plus: '\ue989',
  'pop-out-window': '\ue98b',
  'power-on-off': '\ue98c',
  powertrain: '\uea29',
  pressure: '\ue98d',
  'prevent-turning-fault': '\uea2a',
  print: '\ue98e',
  'program-pointer': '\uea05',
  pump: '\ue98f',
  'qr-code': '\ue990',
  'rapid-tasks': '\uea06',
  rearrange: '\ue991',
  redo: '\ue992',
  refresh: '\ue993',
  reports: '\ue994',
  'reset-user-data': '\uea09',
  resistor: '\ue995',
  'restore-backup': '\uea0a',
  rewind: '\ue996',
  'right-arrow': '\ue998',
  right: '\ue997',
  'robot-axis': '\ue9ec',
  'robot-cabinet': '\ue99a',
  'robot-tool': '\ue99b',
  robot: '\ue999',
  'rotate-left-180': '\ue99d',
  'rotate-left-270': '\ue99e',
  'rotate-left-90': '\ue99c',
  'rotate-right-180': '\ue9a1',
  'rotate-right-270': '\ue99f',
  'rotate-right-90': '\ue9a0',
  'save-as': '\ue9a3',
  save: '\ue9a2',
  screen: '\ue9a4',
  search: '\ue9a5',
  select: '\uea0b',
  'send-to-back': '\ue9a6',
  server: '\ue9a7',
  settings: '\ue9a8',
  share: '\ue9a9',
  shortcut: '\ue9aa',
  shuffle: '\ue9ab',
  'skip-to-end': '\ue9ac',
  'skip-to-start': '\ue9ad',
  'sld-1': '\ue9ae',
  'sld-2': '\ue9af',
  'smart-gripper': '\uea43',
  smartphone: '\ue9b0',
  'software-module': '\ue9fc',
  'software-program-and-modules': '\uea02',
  'software-program-editor': '\uea03',
  'software-program': '\uea04',
  'software-resources': '\uea11',
  'software-routins': '\uea0c',
  'sort-alphabet-down': '\ue9b1',
  'sort-alphabet-up': '\ue9b2',
  'sort-ascending': '\ue9e8',
  'sort-date-down-1': '\ue9b3',
  'sort-date-down-2': '\ue9b4',
  'sort-date-up-1': '\ue9b5',
  'sort-date-up-2': '\ue9b6',
  'sort-descending': '\ue9e9',
  specification: '\ue9b7',
  stairs: '\ue9b8',
  star: '\ue9b9',
  'start-installer': '\uea12',
  'step-in': '\uea13',
  'step-out': '\uea14',
  'step-over': '\uea15',
  stop: '\ue9ba',
  'sun-2': '\ue9bc',
  sun: '\ue9bb',
  synchronize: '\ue9bd',
  system: '\ue9be',
  table: '\ue9bf',
  'target-value-range': '\uea2b',
  'temperature-celsius-1': '\ue9c1',
  'temperature-celsius-2': '\ue9c2',
  'temperature-fahrenheit-1': '\ue9c3',
  'temperature-fahrenheit-2': '\ue9c4',
  temperature: '\ue9c0',
  'template-new': '\ue9c6',
  template: '\ue9c5',
  test: '\ue9c7',
  'text-bold': '\uea3c',
  'text-italic': '\uea3d',
  'text-underline': '\uea3e',
  text: '\ue9c8',
  'thumbnail-view': '\uea2c',
  tiles: '\uf102',
  'time-and-date': '\ue9ca',
  time: '\ue9c9',
  touch: '\uea16',
  'track-1': '\ue9cb',
  'track-2': '\ue9cc',
  train: '\uea2d',
  transformer: '\ue9cd',
  trash: '\ue9ce',
  'tree-view': '\ue9cf',
  'trend-1': '\ue9d0',
  'trend-2': '\ue9d1',
  'trend-3': '\ue9e6',
  'trend-scatter': '\ue9e7',
  'triangle-down': '\uea36',
  'triangle-left': '\uea37',
  'triangle-right': '\uea38',
  'triangle-up': '\uea39',
  turbocharger: '\ue9d2',
  'turn-clockwise-off-target-speed': '\uea19',
  'turn-clockwise': '\uea18',
  'turn-counter-clockwise-off-target-speed': '\uea1a',
  'turn-counter-clockwise': '\uea2e',
  undo: '\ue9d3',
  unpin: '\ue9d4',
  'up-arrow': '\ue9d6',
  up: '\ue9d5',
  upload: '\ue9d7',
  usb: '\ue9d8',
  'user-in-circle': '\ue9da',
  'user-outline': '\uea3f',
  user: '\ue9d9',
  'video-camera-off': '\ue9db',
  'video-camera-on': '\ue9dc',
  'video-chat': '\ue9dd',
  video: '\uea17',
  view: '\ue9de',
  voltage: '\ue9df',
  'warning-circle-1': '\ue9e0',
  'warning-circle-2': '\ue9e1',
  'warning-triangle': '\ue9e2',
  wheel: '\uea2f',
  'wifi-network-disconnected': '\uea31',
  wrench: '\ue9e3',
  'write-to-default-disabled': '\uea33',
  'write-to-default': '\uea32',
  'zoom-in': '\ue9e4',
  'zoom-out': '\ue9e5',
};

const size24 = {
  'add-user': '\ue900',
  'advanced-settings': '\ue9ea',
  'alarm-bell': '\ue901',
  'align-bottom': '\ue902',
  'align-horizontal-center': '\ue903',
  'align-left': '\ue904',
  'align-right': '\ue905',
  'align-top': '\ue906',
  'align-vertical-center': '\ue907',
  align: '\ue9eb',
  'analyze-document': '\ue908',
  anchor: '\ue909',
  'audio-off': '\ue90a',
  'audio-on': '\ue90b',
  background: '\ue90c',
  'bar-chart': '\ue90d',
  'battery-charging': '\ue90e',
  'battery-empty': '\ue90f',
  'battery-full': '\ue910',
  'battery-half': '\ue911',
  'battery-high': '\ue912',
  'battery-low': '\ue913',
  bearing: '\uea1d',
  'binary-data': '\ue914',
  bluetooth: '\ue915',
  bookmark: '\uf101',
  boolean: '\ue916',
  briefcase: '\ue917',
  'bring-to-front': '\ue918',
  broadcast: '\ue919',
  calculator: '\ue91a',
  calendar: '\ue91b',
  calibration: '\ue9ed',
  'call-outline': '\ue9fd',
  call: '\ue91c',
  camera: '\ue91d',
  'caret-down': '\uea08',
  'caret-left': '\uea1c',
  'caret-right': '\uea30',
  'caret-up': '\uea34',
  cart: '\ue91e',
  'certificate-document-1': '\ue91f',
  'certificate-document-2': '\ue920',
  chat: '\ue921',
  'check-mark-circle-1': '\ue923',
  'check-mark-circle-2': '\ue924',
  'check-mark-light': '\uea3a',
  'check-mark': '\ue922',
  'close-light': '\uea35',
  close: '\ue925',
  cloud: '\uea1e',
  comment: '\ue926',
  computer: '\ue927',
  connect: '\ue928',
  connection: '\ue9ee',
  'controller-cabinet': '\ue929',
  'controls-and-settings': '\ue92a',
  copy: '\ue92b',
  'create-backup': '\ue9f0',
  cut: '\ue92c',
  dashboard: '\ue92d',
  'data-editor': '\ue9f1',
  'database-new': '\ue92f',
  database: '\ue92e',
  decimal: '\ue930',
  'delete-drives': '\uea1f',
  devices: '\ue931',
  disconnect: '\ue932',
  distribution: '\ue933',
  'document-excel': '\ue9f8',
  'document-pdf': '\ue9f9',
  'document-word': '\ue9fa',
  document: '\ue934',
  dollar: '\ue935',
  'double-down': '\ue936',
  'double-left': '\ue937',
  'double-right': '\ue938',
  'double-up': '\ue939',
  'down-arrow': '\ue93b',
  down: '\ue93a',
  'download-from-cloud': '\uea20',
  download: '\ue93c',
  'drive-connected': '\uea21',
  drive: '\ue93d',
  'drives-error': '\uea22',
  edge: '\uf103',
  edit: '\ue93e',
  'end-call': '\ue93f',
  envelope: '\ue940',
  'error-circle-1': '\ue941',
  'error-circle-2': '\ue942',
  euro: '\ue943',
  event: '\ue944',
  execution: '\ue9f2',
  export: '\ue945',
  factory: '\ue946',
  fieldbus: '\uea23',
  filter: '\ue947',
  'folder-new': '\ue949',
  'folder-open': '\ue94a',
  folder: '\ue948',
  forward: '\ue94b',
  fullscreen: '\ue94c',
  gauge: '\ue94d',
  gbp: '\ue94e',
  generator: '\uea24',
  globe: '\ue94f',
  group: '\ue950',
  'hardware-devices': '\ue9f3',
  'help-circle-1': '\ue951',
  'help-circle-2': '\ue952',
  hide: '\ue953',
  hierarchy: '\uf104',
  history: '\ue954',
  home: '\ue955',
  'hour-glass': '\ue956',
  image: '\ue957',
  import: '\ue958',
  'information-circle-1': '\ue959',
  'information-circle-2': '\ue95a',
  'io-devices': '\ue9f4',
  'io-signals': '\uea10',
  'jog-linear': '\ue9f7',
  'jog-planar': '\uea01',
  'jog-reorient': '\uea07',
  joystick: '\ue9f5',
  key: '\ue95b',
  label: '\ue95c',
  'lead-through': '\ue9f6',
  'left-arrow': '\ue95e',
  left: '\ue95d',
  level: '\ue95f',
  'light-bulb': '\ue960',
  link: '\ue961',
  'list-2': '\uf105',
  list: '\ue962',
  'location-outline': '\uea25',
  location: '\ue963',
  'lock-closed': '\ue964',
  'lock-open': '\ue965',
  'log-in': '\ue966',
  'log-out': '\ue967',
  magnet: '\ue968',
  'make-same-height': '\ue969',
  'make-same-size': '\ue96a',
  'make-same-width': '\ue96b',
  map: '\ue96c',
  matrix: '\ue96d',
  maximize: '\ue96e',
  'maximum-value': '\uea26',
  'menu-narrow': '\ue970',
  menu: '\ue96f',
  'microphone-off': '\ue972',
  microphone: '\ue971',
  minimize: '\ue973',
  'minimum-value': '\uea27',
  'minus-in-circle': '\ue975',
  minus: '\ue974',
  'missed-call': '\ue976',
  'modify-rapid-position': '\ue9fb',
  moon: '\ue977',
  more: '\ue978',
  motor: '\ue979',
  'network-signal-strength-level-1': '\uea0d',
  'network-signal-strength-level-2': '\uea0e',
  'network-signal-strength-level-3': '\uea0f',
  'network-status-1': '\ue9fe',
  'network-status-2': '\ue9ff',
  'network-status': '\ue9ef',
  network: '\ue97a',
  'new-document': '\ue97b',
  'not-allowed': '\uea28',
  'numbered-list': '\uea3b',
  numericals: '\ue97c',
  'object-container-1': '\ue97e',
  'object-container-2': '\ue97f',
  object: '\ue97d',
  'open-in-new-window': '\ue980',
  panel: '\ue981',
  'paper-clip': '\ue982',
  paste: '\ue983',
  pause: '\ue984',
  payload: '\uea00',
  'pie-chart': '\ue985',
  pin: '\ue986',
  play: '\ue987',
  plugin: '\ue988',
  'plus-in-circle': '\ue98a',
  plus: '\ue989',
  'pop-out-window': '\ue98b',
  'power-on-off': '\ue98c',
  powertrain: '\uea29',
  pressure: '\ue98d',
  'prevent-turning-fault': '\uea2a',
  print: '\ue98e',
  'program-pointer': '\uea05',
  pump: '\ue98f',
  'qr-code': '\ue990',
  'rapid-tasks': '\uea06',
  rearrange: '\ue991',
  redo: '\ue992',
  refresh: '\ue993',
  reports: '\ue994',
  'reset-user-data': '\uea09',
  resistor: '\ue995',
  'restore-backup': '\uea0a',
  rewind: '\ue996',
  'right-arrow': '\ue998',
  right: '\ue997',
  'robot-axis': '\ue9ec',
  'robot-cabinet': '\ue99a',
  'robot-tool': '\ue99b',
  robot: '\ue999',
  'rotate-left-180': '\ue99d',
  'rotate-left-270': '\ue99e',
  'rotate-left-90': '\ue99c',
  'rotate-right-180': '\ue9a1',
  'rotate-right-270': '\ue99f',
  'rotate-right-90': '\ue9a0',
  'save-as': '\ue9a3',
  save: '\ue9a2',
  screen: '\ue9a4',
  search: '\ue9a5',
  select: '\uea0b',
  'send-to-back': '\ue9a6',
  server: '\ue9a7',
  settings: '\ue9a8',
  share: '\ue9a9',
  shortcut: '\ue9aa',
  shuffle: '\ue9ab',
  'skip-to-end': '\ue9ac',
  'skip-to-start': '\ue9ad',
  'sld-1': '\ue9ae',
  'sld-2': '\ue9af',
  'smart-gripper': '\uea43',
  smartphone: '\ue9b0',
  'software-module': '\ue9fc',
  'software-program-and-modules': '\uea02',
  'software-program-editor': '\uea03',
  'software-program': '\uea04',
  'software-resources': '\uea11',
  'software-routins': '\uea0c',
  'sort-alphabet-down': '\ue9b1',
  'sort-alphabet-up': '\ue9b2',
  'sort-ascending': '\ue9e8',
  'sort-date-down-1': '\ue9b3',
  'sort-date-down-2': '\ue9b4',
  'sort-date-up-1': '\ue9b5',
  'sort-date-up-2': '\ue9b6',
  'sort-descending': '\ue9e9',
  specification: '\ue9b7',
  stairs: '\ue9b8',
  star: '\ue9b9',
  'start-installer': '\uea12',
  'step-in': '\uea13',
  'step-out': '\uea14',
  'step-over': '\uea15',
  stop: '\ue9ba',
  'sun-2': '\ue9bc',
  sun: '\ue9bb',
  synchronize: '\ue9bd',
  system: '\ue9be',
  table: '\ue9bf',
  'target-value-range': '\uea2b',
  'temperature-celsius-1': '\ue9c1',
  'temperature-celsius-2': '\ue9c2',
  'temperature-fahrenheit-1': '\ue9c3',
  'temperature-fahrenheit-2': '\ue9c4',
  temperature: '\ue9c0',
  'template-new': '\ue9c6',
  template: '\ue9c5',
  test: '\ue9c7',
  'text-bold': '\uea3c',
  'text-italic': '\uea3d',
  'text-underline': '\uea3e',
  text: '\ue9c8',
  'thumbnail-view': '\uea2c',
  tiles: '\uf102',
  'time-and-date': '\ue9ca',
  time: '\ue9c9',
  touch: '\uea16',
  'track-1': '\ue9cb',
  'track-2': '\ue9cc',
  train: '\uea2d',
  transformer: '\ue9cd',
  trash: '\ue9ce',
  'tree-view': '\ue9cf',
  'trend-1': '\ue9d0',
  'trend-2': '\ue9d1',
  'trend-3': '\ue9e6',
  'trend-scatter': '\ue9e7',
  'triangle-down': '\uea36',
  'triangle-left': '\uea37',
  'triangle-right': '\uea38',
  'triangle-up': '\uea39',
  turbocharger: '\ue9d2',
  'turn-clockwise-off-target-speed': '\uea19',
  'turn-clockwise': '\uea18',
  'turn-counter-clockwise-off-target-speed': '\uea1a',
  'turn-counter-clockwise': '\uea2e',
  undo: '\ue9d3',
  unpin: '\ue9d4',
  'up-arrow': '\ue9d6',
  up: '\ue9d5',
  upload: '\ue9d7',
  usb: '\ue9d8',
  'user-in-circle': '\ue9da',
  'user-outline': '\uea3f',
  user: '\ue9d9',
  'video-camera-off': '\ue9db',
  'video-camera-on': '\ue9dc',
  'video-chat': '\ue9dd',
  video: '\uea17',
  view: '\ue9de',
  voltage: '\ue9df',
  'warning-circle-1': '\ue9e0',
  'warning-circle-2': '\ue9e1',
  'warning-triangle': '\ue9e2',
  wheel: '\uea2f',
  'wifi-network-disconnected': '\uea31',
  wrench: '\ue9e3',
  'write-to-default-disabled': '\uea33',
  'write-to-default': '\uea32',
  'zoom-in': '\ue9e4',
  'zoom-out': '\ue9e5',
};

const size32 = {
  'add-user': '\ue900',
  'advanced-settings': '\ue9ea',
  'alarm-bell': '\ue901',
  'align-bottom': '\ue902',
  'align-horizontal-center': '\ue903',
  'align-left': '\ue904',
  'align-right': '\ue905',
  'align-top': '\ue906',
  'align-vertical-center': '\ue907',
  align: '\ue9eb',
  'analyze-document': '\ue908',
  anchor: '\ue909',
  'audio-off': '\ue90a',
  'audio-on': '\ue90b',
  background: '\ue90c',
  'bar-chart': '\ue90d',
  'battery-charging': '\ue90e',
  'battery-empty': '\ue90f',
  'battery-full': '\ue910',
  'battery-half': '\ue911',
  'battery-high': '\ue912',
  'battery-low': '\ue913',
  bearing: '\uea1d',
  'binary-data': '\ue914',
  bluetooth: '\ue915',
  bookmark: '\uf101',
  boolean: '\ue916',
  briefcase: '\ue917',
  'bring-to-front': '\ue918',
  broadcast: '\ue919',
  calculator: '\ue91a',
  calendar: '\ue91b',
  calibration: '\ue9ed',
  'call-outline': '\ue9fd',
  call: '\ue91c',
  camera: '\ue91d',
  'caret-down': '\uea08',
  'caret-left': '\uea1c',
  'caret-right': '\uea30',
  'caret-up': '\uea34',
  cart: '\ue91e',
  'certificate-document-1': '\ue91f',
  'certificate-document-2': '\ue920',
  chat: '\ue921',
  'check-mark-circle-1': '\ue923',
  'check-mark-circle-2': '\ue924',
  'check-mark-light': '\uea3a',
  'check-mark': '\ue922',
  'close-light': '\uea35',
  close: '\ue925',
  cloud: '\uea1e',
  comment: '\ue926',
  computer: '\ue927',
  connect: '\ue928',
  connection: '\ue9ee',
  'controller-cabinet': '\ue929',
  'controls-and-settings': '\ue92a',
  copy: '\ue92b',
  'create-backup': '\ue9f0',
  cut: '\ue92c',
  dashboard: '\ue92d',
  'data-editor': '\ue9f1',
  'database-new': '\ue92f',
  database: '\ue92e',
  decimal: '\ue930',
  'delete-drives': '\uea1f',
  devices: '\ue931',
  disconnect: '\ue932',
  distribution: '\ue933',
  'document-excel': '\ue9f8',
  'document-pdf': '\ue9f9',
  'document-word': '\ue9fa',
  document: '\ue934',
  dollar: '\ue935',
  'double-down': '\ue936',
  'double-left': '\ue937',
  'double-right': '\ue938',
  'double-up': '\ue939',
  'down-arrow': '\ue93b',
  down: '\ue93a',
  'download-from-cloud': '\uea20',
  download: '\ue93c',
  'drive-connected': '\uea21',
  drive: '\ue93d',
  'drives-error': '\uea22',
  edge: '\uf103',
  edit: '\ue93e',
  'end-call': '\ue93f',
  envelope: '\ue940',
  'error-circle-1': '\ue941',
  'error-circle-2': '\ue942',
  euro: '\ue943',
  event: '\ue944',
  execution: '\ue9f2',
  export: '\ue945',
  factory: '\ue946',
  fieldbus: '\uea23',
  filter: '\ue947',
  'folder-new': '\ue949',
  'folder-open': '\ue94a',
  folder: '\ue948',
  forward: '\ue94b',
  fullscreen: '\ue94c',
  gauge: '\ue94d',
  gbp: '\ue94e',
  generator: '\uea24',
  globe: '\ue94f',
  group: '\ue950',
  'hardware-devices': '\ue9f3',
  'help-circle-1': '\ue951',
  'help-circle-2': '\ue952',
  hide: '\ue953',
  hierarchy: '\uf104',
  history: '\ue954',
  home: '\ue955',
  'hour-glass': '\ue956',
  image: '\ue957',
  import: '\ue958',
  'information-circle-1': '\ue959',
  'information-circle-2': '\ue95a',
  'io-devices': '\ue9f4',
  'io-signals': '\uea10',
  'jog-linear': '\ue9f7',
  'jog-planar': '\uea01',
  'jog-reorient': '\uea07',
  joystick: '\ue9f5',
  key: '\ue95b',
  label: '\ue95c',
  'lead-through': '\ue9f6',
  'left-arrow': '\ue95e',
  left: '\ue95d',
  level: '\ue95f',
  'light-bulb': '\ue960',
  link: '\ue961',
  'list-2': '\uf105',
  list: '\ue962',
  'location-outline': '\uea25',
  location: '\ue963',
  'lock-closed': '\ue964',
  'lock-open': '\ue965',
  'log-in': '\ue966',
  'log-out': '\ue967',
  magnet: '\ue968',
  'make-same-height': '\ue969',
  'make-same-size': '\ue96a',
  'make-same-width': '\ue96b',
  map: '\ue96c',
  matrix: '\ue96d',
  maximize: '\ue96e',
  'maximum-value': '\uea26',
  'menu-narrow': '\ue970',
  menu: '\ue96f',
  'microphone-off': '\ue972',
  microphone: '\ue971',
  minimize: '\ue973',
  'minimum-value': '\uea27',
  'minus-in-circle': '\ue975',
  minus: '\ue974',
  'missed-call': '\ue976',
  'modify-rapid-position': '\ue9fb',
  moon: '\ue977',
  more: '\ue978',
  motor: '\ue979',
  'network-signal-strength-level-1': '\uea0d',
  'network-signal-strength-level-2': '\uea0e',
  'network-signal-strength-level-3': '\uea0f',
  'network-status-1': '\ue9fe',
  'network-status-2': '\ue9ff',
  'network-status': '\ue9ef',
  network: '\ue97a',
  'new-document': '\ue97b',
  'not-allowed': '\uea28',
  'numbered-list': '\uea3b',
  numericals: '\ue97c',
  'object-container-1': '\ue97e',
  'object-container-2': '\ue97f',
  object: '\ue97d',
  'open-in-new-window': '\ue980',
  panel: '\ue981',
  'paper-clip': '\ue982',
  paste: '\ue983',
  pause: '\ue984',
  payload: '\uea00',
  'pie-chart': '\ue985',
  pin: '\ue986',
  play: '\ue987',
  plugin: '\ue988',
  'plus-in-circle': '\ue98a',
  plus: '\ue989',
  'pop-out-window': '\ue98b',
  'power-on-off': '\ue98c',
  powertrain: '\uea29',
  pressure: '\ue98d',
  'prevent-turning-fault': '\uea2a',
  print: '\ue98e',
  'program-pointer': '\uea05',
  pump: '\ue98f',
  'qr-code': '\ue990',
  'rapid-tasks': '\uea06',
  rearrange: '\ue991',
  redo: '\ue992',
  refresh: '\ue993',
  reports: '\ue994',
  'reset-user-data': '\uea09',
  resistor: '\ue995',
  'restore-backup': '\uea0a',
  rewind: '\ue996',
  'right-arrow': '\ue998',
  right: '\ue997',
  'robot-axis': '\ue9ec',
  'robot-cabinet': '\ue99a',
  'robot-tool': '\ue99b',
  robot: '\ue999',
  'rotate-left-180': '\ue99d',
  'rotate-left-270': '\ue99e',
  'rotate-left-90': '\ue99c',
  'rotate-right-180': '\ue9a1',
  'rotate-right-270': '\ue99f',
  'rotate-right-90': '\ue9a0',
  'save-as': '\ue9a3',
  save: '\ue9a2',
  screen: '\ue9a4',
  search: '\ue9a5',
  select: '\uea0b',
  'send-to-back': '\ue9a6',
  server: '\ue9a7',
  settings: '\ue9a8',
  share: '\ue9a9',
  shortcut: '\ue9aa',
  shuffle: '\ue9ab',
  'skip-to-end': '\ue9ac',
  'skip-to-start': '\ue9ad',
  'sld-1': '\ue9ae',
  'sld-2': '\ue9af',
  'smart-gripper': '\uea43',
  smartphone: '\ue9b0',
  'software-module': '\ue9fc',
  'software-program-and-modules': '\uea02',
  'software-program-editor': '\uea03',
  'software-program': '\uea04',
  'software-resources': '\uea11',
  'software-routins': '\uea0c',
  'sort-alphabet-down': '\ue9b1',
  'sort-alphabet-up': '\ue9b2',
  'sort-ascending': '\ue9e8',
  'sort-date-down-1': '\ue9b3',
  'sort-date-down-2': '\ue9b4',
  'sort-date-up-1': '\ue9b5',
  'sort-date-up-2': '\ue9b6',
  'sort-descending': '\ue9e9',
  specification: '\ue9b7',
  stairs: '\ue9b8',
  star: '\ue9b9',
  'start-installer': '\uea12',
  'step-in': '\uea13',
  'step-out': '\uea14',
  'step-over': '\uea15',
  stop: '\ue9ba',
  'sun-2': '\ue9bc',
  sun: '\ue9bb',
  synchronize: '\ue9bd',
  system: '\ue9be',
  table: '\ue9bf',
  'target-value-range': '\uea2b',
  'temperature-celsius-1': '\ue9c1',
  'temperature-celsius-2': '\ue9c2',
  'temperature-fahrenheit-1': '\ue9c3',
  'temperature-fahrenheit-2': '\ue9c4',
  temperature: '\ue9c0',
  'template-new': '\ue9c6',
  template: '\ue9c5',
  test: '\ue9c7',
  'text-bold': '\uea3c',
  'text-italic': '\uea3d',
  'text-underline': '\uea3e',
  text: '\ue9c8',
  'thumbnail-view': '\uea2c',
  tiles: '\uf102',
  'time-and-date': '\ue9ca',
  time: '\ue9c9',
  touch: '\uea16',
  'track-1': '\ue9cb',
  'track-2': '\ue9cc',
  train: '\uea2d',
  transformer: '\ue9cd',
  trash: '\ue9ce',
  'tree-view': '\ue9cf',
  'trend-1': '\ue9d0',
  'trend-2': '\ue9d1',
  'trend-3': '\ue9e6',
  'trend-scatter': '\ue9e7',
  'triangle-down': '\uea36',
  'triangle-left': '\uea37',
  'triangle-right': '\uea38',
  'triangle-up': '\uea39',
  turbocharger: '\ue9d2',
  'turn-clockwise-off-target-speed': '\uea19',
  'turn-clockwise': '\uea18',
  'turn-counter-clockwise-off-target-speed': '\uea1a',
  'turn-counter-clockwise': '\uea2e',
  undo: '\ue9d3',
  unpin: '\ue9d4',
  'up-arrow': '\ue9d6',
  up: '\ue9d5',
  upload: '\ue9d7',
  usb: '\ue9d8',
  'user-in-circle': '\ue9da',
  'user-outline': '\uea3f',
  user: '\ue9d9',
  'video-camera-off': '\ue9db',
  'video-camera-on': '\ue9dc',
  'video-chat': '\ue9dd',
  video: '\uea17',
  view: '\ue9de',
  voltage: '\ue9df',
  'warning-circle-1': '\ue9e0',
  'warning-circle-2': '\ue9e1',
  'warning-triangle': '\ue9e2',
  wheel: '\uea2f',
  'wifi-network-disconnected': '\uea31',
  wrench: '\ue9e3',
  'write-to-default-disabled': '\uea33',
  'write-to-default': '\uea32',
  'zoom-in': '\ue9e4',
  'zoom-out': '\ue9e5',
};

export const abbIconsMapper = {
  small: size16,
  medium: size24,
  large: size32,
};

export const materialIcons = [
  'search',
  'search',
  'home',
  'account_circle',
  'settings',
  'done',
  'info',
  'check_circle',
  'delete',
  'visibility',
  'shopping_cart',
  'favorite',
  'description',
  'logout',
  'favorite_border',
  'lock',
  'schedule',
  'language',
  'help_outline',
  'face',
  'manage_accounts',
  'verified',
  'thumb_up',
  'filter_alt',
  'event',
  'fingerprint',
  'dashboard',
  'list',
  'check_circle_outline',
  'login',
  'visibility_off',
  'calendar_today',
  'highlight_off',
  'help',
  'paid',
  'task_alt',
  'question_answer',
  'date_range',
  'article',
  'open_in_new',
  'shopping_bag',
  'lightbulb',
  'credit_card',
  'perm_identity',
  'history',
  'trending_up',
  'account_balance',
  'delete_outline',
  'verified_user',
  'fact_check',
  'report_problem',
  'assignment',
  'star_rate',
  'arrow_right_alt',
  'account_balance_wallet',
  'autorenew',
  'calendar_month',
  'build',
  'view_list',
  'store',
  'work',
  'print',
  'analytics',
  'delete_forever',
  'today',
  'admin_panel_settings',
  'lock_open',
  'watch_later',
  'grade',
  'update',
  'savings',
  'room',
  'code',
  'add_shopping_cart',
  'contact_support',
  'receipt',
  'power_settings_new',
  'done_all',
  'pets',
  'explore',
  'bookmark',
  'note_add',
  'account_box',
  'reorder',
  'pending_actions',
  'bookmark_border',
  'shopping_basket',
  'payment',
  'launch',
  'drag_indicator',
  'supervisor_account',
  'touch_app',
  'pending',
  'zoom_in',
  'assessment',
  'leaderboard',
  'thumb_up_off_alt',
  'open_in_full',
  'done_outline',
  'preview',
  'assignment_ind',
  'exit_to_app',
  'published_with_changes',
  'card_giftcard',
  'view_in_ar',
  'feedback',
  'label',
  'tips_and_updates',
  'swap_horiz',
  'timeline',
  'work_outline',
  'stars',
  'assignment_turned_in',
  'dns',
  'sync_alt',
  'flight_takeoff',
  'space_dashboard',
  'contact_page',
  'alarm',
  'book',
  'bug_report',
  'cached',
  'translate',
  'gavel',
  'pan_tool',
  'edit_calendar',
  'supervised_user_circle',
  'minimize',
  'rocket_launch',
  'question_mark',
  'extension',
  'android',
  'accessibility',
  'get_app',
  'record_voice_over',
  'add_task',
  'hourglass_empty',
  'help_center',
  'trending_flat',
  'rule',
  'accessibility_new',
  'thumb_down',
  'sticky_note_2',
  'ads_click',
  'settings_applications',
  'source',
  'find_in_page',
  'dashboard_customize',
  'swap_vert',
  'support',
  'redeem',
  'flutter_dash',
  'close_fullscreen',
  'loyalty',
  'announcement',
  'arrow_circle_right',
  'view_headline',
  'restore',
  'dangerous',
  'euro_symbol',
  'sensors',
  'group_work',
  'currency_exchange',
  'compare_arrows',
  'table_view',
  'subject',
  'disabled_by_default',
  'privacy_tip',
  'nightlight_round',
  'https',
  'toc',
  'bookmarks',
  'arrow_circle_up',
  'track_changes',
  'input',
  'view_module',
  'copyright',
  'api',
  'grading',
  'query_builder',
  'perm_media',
  'build_circle',
  'perm_contact_calendar',
  'zoom_out',
  'settings_phone',
  'backup',
  'open_with',
  'circle_notifications',
  'perm_phone_msg',
  'speaker_notes',
  'wysiwyg',
  'card_membership',
  'label_important',
  'book_online',
  'file_present',
  'arrow_circle_down',
  'pageview',
  '3d_rotation',
  'upgrade',
  'change_history',
  'integration_instructions',
  'trending_down',
  'percent',
  'class',
  'swipe',
  'accessible',
  'g_translate',
  'settings_accessibility',
  'expand',
  'offline_bolt',
  'production_quantity_limits',
  'settings_backup_restore',
  'arrow_circle_left',
  'aspect_ratio',
  'model_training',
  'view_column',
  'donut_large',
  'segment',
  'calendar_view_month',
  'alarm_on',
  'schedule_send',
  'maximize',
  'settings_ethernet',
  'thumbs_up_down',
  'bookmark_add',
  'theaters',
  'view_agenda',
  'thumb_down_off_alt',
  'important_devices',
  'unpublished',
  'system_update_alt',
  'opacity',
  'commute',
  'open_in_browser',
  'invert_colors',
  'no_accounts',
  'addchart',
  'history_toggle_off',
  'view_week',
  'shopping_cart_checkout',
  'youtube_searched_for',
  'tour',
  'hide_source',
  'search_off',
  'bookmark_added',
  'shop',
  'not_started',
  'mark_as_unread',
  'plagiarism',
  'settings_input_antenna',
  'turned_in',
  'flight_land',
  'filter_alt_off',
  'assignment_return',
  'balance',
  'hotel_class',
  'assignment_late',
  'donut_small',
  'contactless',
  'saved_search',
  'highlight_alt',
  'settings_input_component',
  'view_carousel',
  'view_quilt',
  'all_inbox',
  'anchor',
  'settings_remote',
  'rocket',
  'edit_off',
  'hourglass_full',
  'turned_in_not',
  'mediation',
  'fit_screen',
  'remove_shopping_cart',
  'flaky',
  'toll',
  'lock_clock',
  'swap_horizontal_circle',
  'terminal',
  'view_sidebar',
  'settings_voice',
  'event_seat',
  'vertical_split',
  'lock_reset',
  'online_prediction',
  'data_exploration',
  'next_plan',
  'pregnant_woman',
  'restore_from_trash',
  'camera_enhance',
  'markunread_mailbox',
  'dynamic_form',
  'tab',
  'view_stream',
  'calendar_view_week',
  'request_page',
  'token',
  'accessible_forward',
  'remove_done',
  'smart_button',
  'settings_power',
  'add_to_drive',
  'outbox',
  'try',
  'card_travel',
  'density_medium',
  'add_card',
  'offline_pin',
  'fax',
  'find_replace',
  'compress',
  'calendar_view_day',
  'assignment_returned',
  'rowing',
  'chrome_reader_mode',
  'outlet',
  'work_history',
  'http',
  'generating_tokens',
  'settings_brightness',
  'new_label',
  'backup_table',
  'free_cancellation',
  'alarm_add',
  'spellcheck',
  'restore_page',
  '123',
  'credit_card_off',
  'wifi_protected_setup',
  'play_for_work',
  'assured_workload',
  'settings_overscan',
  'disabled_visible',
  'event_repeat',
  'display_settings',
  'pan_tool_alt',
  'noise_control_off',
  'gif',
  'outbound',
  'view_timeline',
  'swap_vertical_circle',
  'cancel_schedule_send',
  'settings_input_composite',
  'switch_access_shortcut',
  'quickreply',
  'view_day',
  'manage_history',
  'comment_bank',
  'webhook',
  'satellite_alt',
  'line_weight',
  'horizontal_split',
  'polymer',
  'batch_prediction',
  'send_and_archive',
  'picture_in_picture',
  'code_off',
  'bookmark_remove',
  'output',
  'settings_bluetooth',
  'html',
  'troubleshoot',
  'shop_two',
  'flip_to_front',
  'gif_box',
  'speaker_notes_off',
  'eject',
  'alarm_off',
  'perm_data_setting',
  'settings_input_hdmi',
  'switch_access_shortcut_add',
  'hourglass_disabled',
  'perm_scan_wifi',
  'sensors_off',
  'work_off',
  'settings_cell',
  'app_blocking',
  'picture_in_picture_alt',
  'join_full',
  'line_style',
  'perm_device_information',
  'javascript',
  'app_shortcut',
  'abc',
  'subtitles_off',
  'update_disabled',
  'swipe_left',
  'lightbulb_circle',
  'voice_over_off',
  'private_connectivity',
  'join_inner',
  'settings_input_svideo',
  'install_desktop',
  'swipe_right',
  'flip_to_back',
  'swipe_up',
  'view_array',
  'arrow_outward',
  'open_in_new_off',
  'all_out',
  'density_small',
  'shop_2',
  'label_off',
  'data_thresholding',
  'tab_unselected',
  'rounded_corner',
  'commit',
  'text_rotate_vertical',
  'explore_off',
  'view_kanban',
  'lock_person',
  'install_mobile',
  'text_rotation_none',
  'css',
  'swipe_down',
  'not_accessible',
  'spatial_audio_off',
  'join_left',
  'pin_invoke',
  'pinch',
  'noise_aware',
  'extension_off',
  'perm_camera_mic',
  'swipe_vertical',
  'view_cozy',
  'join_right',
  'pin_end',
  'swipe_right_alt',
  'text_rotate_up',
  'text_rotation_angledown',
  'php',
  'browse_gallery',
  'text_rotation_angleup',
  'text_rotation_down',
  'view_comfy_alt',
  'view_compact_alt',
  'add_home',
  'network_ping',
  'swipe_down_alt',
  'unfold_more_double',
  'on_device_training',
  'density_large',
  'spatial_tracking',
  'swipe_left_alt',
  'swipe_up_alt',
  'spatial_audio',
  'unfold_less_double',
  'width_full',
  'repartition',
  'width_normal',
  'transcribe',
  'width_wide',
  'hls',
  'hls_off',
  'face_unlock',
  'close',
  'close',
  'menu',
  'expand_more',
  'arrow_back',
  'chevron_right',
  'arrow_forward_ios',
  'arrow_back_ios',
  'cancel',
  'arrow_drop_down',
  'more_vert',
  'arrow_forward',
  'chevron_left',
  'expand_less',
  'check',
  'more_horiz',
  'refresh',
  'apps',
  'payments',
  'arrow_upward',
  'east',
  'campaign',
  'arrow_back_ios_new',
  'arrow_downward',
  'arrow_right',
  'menu_open',
  'fullscreen',
  'arrow_drop_up',
  'unfold_more',
  'double_arrow',
  'maps_home_work',
  'west',
  'expand_circle_down',
  'arrow_left',
  'south',
  'north_east',
  'north',
  'home_work',
  'first_page',
  'fullscreen_exit',
  'arrow_drop_down_circle',
  'last_page',
  'unfold_less',
  'subdirectory_arrow_right',
  'legend_toggle',
  'south_east',
  'app_settings_alt',
  'assistant_direction',
  'subdirectory_arrow_left',
  'north_west',
  'waterfall_chart',
  'switch_left',
  'south_west',
  'pivot_table_chart',
  'switch_right',
  'apps_outage',
  'offline_share',
  'add_home_work',
  'person',
  'person',
  'notifications',
  'groups',
  'people',
  'share',
  'school',
  'person_outline',
  'person_add',
  'public',
  'emoji_events',
  'group',
  'engineering',
  'notifications_active',
  'construction',
  'people_alt',
  'group_add',
  'psychology',
  'thumb_up_alt',
  'health_and_safety',
  'travel_explore',
  'water_drop',
  'notifications_none',
  'emoji_emotions',
  'sports_esports',
  'sentiment_very_satisfied',
  'workspace_premium',
  'location_city',
  'ios_share',
  'precision_manufacturing',
  'sentiment_satisfied',
  'person_add_alt',
  'military_tech',
  'science',
  'emoji_objects',
  'history_edu',
  'cake',
  'sentiment_dissatisfied',
  'handshake',
  'sentiment_very_dissatisfied',
  'emoji_people',
  'coronavirus',
  'self_improvement',
  'person_remove',
  'poll',
  'whatshot',
  'sports_soccer',
  'domain',
  'recommend',
  'mood',
  'people_outline',
  'female',
  'recycling',
  'person_off',
  'male',
  'person_add_alt_1',
  'sentiment_neutral',
  'connect_without_contact',
  'thumb_down_alt',
  'waving_hand',
  'back_hand',
  'hiking',
  'architecture',
  'notifications_off',
  'real_estate_agent',
  'masks',
  'luggage',
  'front_hand',
  'vaccines',
  'mood_bad',
  'emoji_nature',
  'switch_account',
  'compost',
  'nights_stay',
  'interests',
  'king_bed',
  'catching_pokemon',
  'diversity_3',
  'sports_basketball',
  'notification_add',
  'cruelty_free',
  'sports_kabaddi',
  'sports',
  'man',
  'reduce_capacity',
  'emoji_symbols',
  'emoji_food_beverage',
  'sick',
  'emoji_transportation',
  'heart_broken',
  'cookie',
  'sports_tennis',
  'elderly',
  'transgender',
  'add_reaction',
  'add_moderator',
  'woman',
  'outdoor_grill',
  'personal_injury',
  'wallet',
  'deck',
  'diversity_1',
  'scale',
  'follow_the_signs',
  'social_distance',
  'plus_one',
  'fireplace',
  'clean_hands',
  'pix',
  'piano',
  'surfing',
  'sports_motorsports',
  'sanitizer',
  'sports_handball',
  'sports_baseball',
  'hive',
  'edit_notifications',
  'groups_2',
  'sports_volleyball',
  'psychology_alt',
  'pages',
  'sports_football',
  'diversity_2',
  'downhill_skiing',
  'kayaking',
  'public_off',
  'group_remove',
  'co2',
  'single_bed',
  'remove_moderator',
  'skateboarding',
  'notifications_paused',
  'boy',
  'domain_add',
  'person_remove_alt_1',
  'safety_divider',
  'fitbit',
  'group_off',
  'sports_cricket',
  'sports_mma',
  'thunderstorm',
  'sports_martial_arts',
  'nordic_walking',
  'sports_golf',
  'girl',
  'groups_3',
  'paragliding',
  'sports_gymnastics',
  'party_mode',
  'face_6',
  'snowboarding',
  '6_ft_apart',
  'kitesurfing',
  'face_3',
  'snowshoeing',
  'south_america',
  'sports_hockey',
  'ice_skating',
  'elderly_woman',
  'sports_rugby',
  'person_2',
  'sledding',
  'scoreboard',
  'face_2',
  'face_4',
  'sign_language',
  'cyclone',
  'person_4',
  'face_5',
  'no_luggage',
  'person_3',
  'flood',
  'scuba_diving',
  'piano_off',
  'severe_cold',
  'tsunami',
  'roller_skating',
  'tornado',
  'landslide',
  'assist_walker',
  'woman_2',
  'man_2',
  'blind',
  '18_up_rating',
  'volcano',
  'no_adult_content',
  'man_4',
  'man_3',
  'add',
  'add',
  'add_circle_outline',
  'content_copy',
  'add_circle',
  'send',
  'clear',
  'save',
  'mail',
  'link',
  'remove',
  'filter_list',
  'inventory_2',
  'inventory',
  'insights',
  'remove_circle_outline',
  'sort',
  'bolt',
  'flag',
  'reply',
  'add_box',
  'remove_circle',
  'push_pin',
  'block',
  'calculate',
  'create',
  'undo',
  'how_to_reg',
  'content_paste',
  'report',
  'file_copy',
  'backspace',
  'shield',
  'archive',
  'save_alt',
  'policy',
  'change_circle',
  'tag',
  'redo',
  'forward',
  'content_cut',
  'outlined_flag',
  'inbox',
  'link_off',
  'ballot',
  'drafts',
  'biotech',
  'report_gmailerrorred',
  'delete_sweep',
  'stacked_bar_chart',
  'markunread',
  'square_foot',
  'add_link',
  'stream',
  'copy_all',
  'dynamic_feed',
  'where_to_vote',
  'move_to_inbox',
  'waves',
  'content_paste_search',
  'unarchive',
  'reply_all',
  'select_all',
  'low_priority',
  'text_format',
  'save_as',
  'font_download',
  'weekend',
  'how_to_vote',
  'upcoming',
  'gesture',
  'attribution',
  'flag_circle',
  'content_paste_go',
  'filter_list_off',
  'next_week',
  'content_paste_off',
  'web_stories',
  'report_off',
  'deselect',
  'font_download_off',
  'edit',
  'edit',
  'navigate_next',
  'photo_camera',
  'image',
  'tune',
  'picture_as_pdf',
  'receipt_long',
  'circle',
  'timer',
  'auto_stories',
  'auto_awesome',
  'collections',
  'navigate_before',
  'add_a_photo',
  'palette',
  'remove_red_eye',
  'music_note',
  'add_photo_alternate',
  'wb_sunny',
  'brush',
  'euro',
  'flash_on',
  'auto_fix_high',
  'looks_one',
  'control_point',
  'style',
  'adjust',
  'straighten',
  'photo_library',
  'camera',
  'portrait',
  'camera_alt',
  'audiotrack',
  'rotate_right',
  'color_lens',
  'video_camera_front',
  'grid_on',
  'crop_free',
  'timelapse',
  'currency_rupee',
  'landscape',
  'slideshow',
  'collections_bookmark',
  'crop_square',
  'panorama_fish_eye',
  'lens',
  'looks_two',
  'looks_3',
  'filter_vintage',
  'compare',
  'filter_drama',
  'image_search',
  'healing',
  'rotate_left',
  'center_focus_strong',
  'auto_awesome_motion',
  'crop',
  'blur_on',
  'wb_incandescent',
  'face_retouching_natural',
  'assistant',
  'flare',
  'broken_image',
  'wb_cloudy',
  'cases',
  'filter_none',
  'colorize',
  'filter_center_focus',
  'auto_fix_normal',
  'crop_original',
  'brightness_4',
  'nature_people',
  'dehaze',
  'photo',
  'flash_off',
  'auto_awesome_mosaic',
  'tag_faces',
  'brightness_6',
  'brightness_5',
  'details',
  'grain',
  'brightness_1',
  'flip_camera_android',
  'flip',
  'loupe',
  'view_comfy',
  'image_not_supported',
  'flip_camera_ios',
  'filter_1',
  'movie_creation',
  'bedtime',
  'add_to_photos',
  'looks_4',
  'panorama',
  'animation',
  'center_focus_weak',
  'movie_filter',
  'crop_din',
  'currency_bitcoin',
  'filter',
  'control_point_duplicate',
  'brightness_7',
  'leak_add',
  'incomplete_circle',
  'nature',
  'view_compact',
  'texture',
  'currency_yen',
  'timer_off',
  'video_camera_back',
  'photo_size_select_actual',
  'transform',
  'motion_photos_on',
  'looks_5',
  'rotate_90_degrees_ccw',
  'photo_camera_front',
  'contrast',
  'mic_external_on',
  'gradient',
  'wb_twilight',
  'currency_pound',
  'assistant_photo',
  'hide_image',
  'exposure_plus_1',
  'music_off',
  'crop_16_9',
  'exposure',
  'thermostat_auto',
  'shutter_speed',
  'filter_2',
  'photo_album',
  'filter_tilt_shift',
  'hdr_strong',
  'looks',
  'brightness_3',
  'looks_6',
  'linked_camera',
  'vrpano',
  'blur_circular',
  'flash_auto',
  'crop_portrait',
  'motion_photos_auto',
  'photo_filter',
  'iso',
  'brightness_2',
  'photo_size_select_small',
  'filter_hdr',
  'crop_7_5',
  'tonality',
  'rotate_90_degrees_cw',
  'crop_rotate',
  'photo_size_select_large',
  'exposure_zero',
  'filter_3',
  'currency_ruble',
  'camera_front',
  'hdr_weak',
  'crop_5_4',
  'filter_frames',
  'burst_mode',
  'camera_roll',
  'logo_dev',
  'filter_b_and_w',
  'blur_linear',
  'crop_landscape',
  'crop_3_2',
  'switch_camera',
  'switch_video',
  'filter_7',
  'filter_4',
  'filter_9_plus',
  'exposure_plus_2',
  'wb_iridescent',
  'grid_off',
  'photo_camera_back',
  'motion_photos_paused',
  'monochrome_photos',
  'auto_fix_off',
  'filter_5',
  'exposure_neg_1',
  'face_retouching_off',
  'panorama_photosphere',
  'leak_remove',
  'filter_9',
  'filter_8',
  'timer_10',
  'video_stable',
  'filter_6',
  'wb_shade',
  'motion_photos_off',
  'raw_on',
  'blur_off',
  'motion_photos_pause',
  'hdr_on',
  'vignette',
  'deblur',
  'panorama_horizontal',
  'image_aspect_ratio',
  '30fps_select',
  'dirty_lens',
  'camera_rear',
  'timer_3',
  'currency_lira',
  'currency_yuan',
  '60fps_select',
  'panorama_wide_angle_select',
  '24mp',
  'exposure_neg_2',
  'autofps_select',
  'panorama_horizontal_select',
  'panorama_photosphere_select',
  'wb_auto',
  'hdr_plus',
  'panorama_wide_angle',
  'panorama_vertical_select',
  'mic_external_off',
  '12mp',
  'panorama_vertical',
  'currency_franc',
  'mp',
  'hdr_enhanced_select',
  'hevc',
  '18mp',
  '10mp',
  'bedtime_off',
  'raw_off',
  '23mp',
  'hdr_off',
  '11mp',
  '20mp',
  '3mp',
  '5mp',
  '13mp',
  '16mp',
  '21mp',
  '15mp',
  '2mp',
  '17mp',
  '14mp',
  '19mp',
  '22mp',
  '4mp',
  '9mp',
  '7mp',
  '8mp',
  '6mp',
  'email',
  'email',
  'location_on',
  'call',
  'phone',
  'business',
  'chat',
  'mail_outline',
  'list_alt',
  'qr_code_scanner',
  'vpn_key',
  'chat_bubble_outline',
  'alternate_email',
  'forum',
  'chat_bubble',
  'textsms',
  'contact_mail',
  'person_search',
  'sentiment_satisfied_alt',
  'qr_code',
  'qr_code_2',
  'message',
  'contacts',
  'comment',
  'key',
  'import_contacts',
  'app_registration',
  'contact_phone',
  'import_export',
  'live_help',
  'forward_to_inbox',
  'hourglass_bottom',
  'hourglass_top',
  'rss_feed',
  'mark_email_read',
  'hub',
  'read_more',
  'document_scanner',
  'more_time',
  'mark_email_unread',
  'call_end',
  'clear_all',
  'dialpad',
  'phone_enabled',
  'mark_chat_unread',
  'cancel_presentation',
  '3p',
  'call_made',
  'screen_share',
  'call_split',
  'unsubscribe',
  'domain_verification',
  'present_to_all',
  'mark_chat_read',
  'co_present',
  'add_ic_call',
  'phonelink_ring',
  'call_received',
  'stay_current_portrait',
  'phonelink_lock',
  'phone_disabled',
  'ring_volume',
  'cell_tower',
  'location_off',
  'phonelink_setup',
  'duo',
  'stay_primary_portrait',
  'swap_calls',
  'voicemail',
  'call_merge',
  'phonelink_erase',
  'mobile_screen_share',
  'person_add_disabled',
  'domain_disabled',
  'call_missed_outgoing',
  'spoke',
  'speaker_phone',
  'desktop_access_disabled',
  'cell_wifi',
  'stop_screen_share',
  'mark_unread_chat_alt',
  'print_disabled',
  'contact_emergency',
  'call_missed',
  'pause_presentation',
  'dialer_sip',
  'comments_disabled',
  'invert_colors_off',
  'wifi_calling',
  'rtt',
  'portable_wifi_off',
  'send_time_extension',
  'mail_lock',
  'stay_current_landscape',
  'sip',
  'nat',
  'stay_primary_landscape',
  'key_off',
  'no_sim',
  'vpn_key_off',
  'local_shipping',
  'local_shipping',
  'place',
  'menu_book',
  'local_offer',
  'badge',
  'map',
  'category',
  'restaurant',
  'directions_car',
  'local_fire_department',
  'volunteer_activism',
  'my_location',
  'flight',
  'local_mall',
  'near_me',
  'handyman',
  'directions_run',
  'restaurant_menu',
  'layers',
  'medical_services',
  'directions_walk',
  'lunch_dining',
  'local_hospital',
  'celebration',
  'local_library',
  'pin_drop',
  'park',
  'local_atm',
  'local_activity',
  'person_pin',
  'design_services',
  'local_cafe',
  'delivery_dining',
  'rate_review',
  'directions_bus',
  'local_police',
  'directions_bike',
  'fastfood',
  'directions_car_filled',
  'home_repair_service',
  'zoom_out_map',
  'cleaning_services',
  'hotel',
  'local_phone',
  'miscellaneous_services',
  'local_grocery_store',
  'navigation',
  'local_gas_station',
  'train',
  'diamond',
  'person_pin_circle',
  'local_parking',
  'local_florist',
  'local_post_office',
  'money',
  'factory',
  'directions',
  'two_wheeler',
  'add_business',
  'electrical_services',
  'traffic',
  'route',
  'directions_boat',
  'local_bar',
  'alt_route',
  'warehouse',
  'agriculture',
  'beenhere',
  'pedal_bike',
  'emergency',
  '360',
  'liquor',
  'moving',
  'local_airport',
  'sailing',
  'add_location_alt',
  'local_dining',
  'maps_ugc',
  'local_taxi',
  'ramen_dining',
  'trip_origin',
  'local_laundry_service',
  'hail',
  'directions_bus_filled',
  'local_drink',
  'local_printshop',
  'theater_comedy',
  'local_pizza',
  'forest',
  'not_listed_location',
  'transfer_within_a_station',
  'add_location',
  'dinner_dining',
  'bakery_dining',
  'wine_bar',
  'terrain',
  'multiple_stop',
  'takeout_dining',
  'store_mall_directory',
  'icecream',
  'museum',
  'nightlife',
  'local_pharmacy',
  'hardware',
  'departure_board',
  'add_road',
  'set_meal',
  'ev_station',
  'electric_car',
  'local_see',
  'festival',
  'plumbing',
  'car_rental',
  'layers_clear',
  'medical_information',
  'attractions',
  'edit_location',
  'zoom_in_map',
  'local_convenience_store',
  'pest_control',
  'run_circle',
  'dry_cleaning',
  'edit_road',
  'church',
  'edit_attributes',
  'edit_location_alt',
  'wrong_location',
  'car_repair',
  'moped',
  'local_movies',
  'satellite',
  'directions_boat_filled',
  'soup_kitchen',
  'signpost',
  'tram',
  'taxi_alert',
  'breakfast_dining',
  'merge',
  'straight',
  'atm',
  'subway',
  'transit_enterexit',
  'crisis_alert',
  'brunch_dining',
  'hvac',
  'electric_bike',
  'directions_transit',
  'connecting_airports',
  'electric_scooter',
  'egg',
  'bus_alert',
  'mode_of_travel',
  'local_car_wash',
  'safety_check',
  'local_hotel',
  'stadium',
  'castle',
  'streetview',
  'car_crash',
  'mosque',
  'directions_subway',
  'compass_calibration',
  'electric_rickshaw',
  'turn_right',
  'airline_stops',
  'directions_railway',
  'fork_right',
  'no_meals',
  'railway_alert',
  'electric_moped',
  'no_crash',
  'local_play',
  'turn_left',
  'airlines',
  'u_turn_left',
  'bike_scooter',
  'pest_control_rodent',
  'egg_alt',
  'near_me_disabled',
  'snowmobile',
  'directions_transit_filled',
  'tire_repair',
  'minor_crash',
  'no_transfer',
  'directions_subway_filled',
  'flight_class',
  'kebab_dining',
  'sos',
  'directions_railway_filled',
  'temple_buddhist',
  'fort',
  'emergency_share',
  'fire_truck',
  'u_turn_right',
  'temple_hindu',
  'synagogue',
  'fork_left',
  'remove_road',
  'screen_rotation_alt',
  'turn_sharp_right',
  'roundabout_right',
  'turn_slight_right',
  'turn_slight_left',
  'emergency_recording',
  'roundabout_left',
  'turn_sharp_left',
  'ramp_left',
  'ramp_right',
  'fire_hydrant_alt',
  'file_download',
  'file_download',
  'file_upload',
  'download',
  'folder',
  'grid_view',
  'upload_file',
  'cloud_upload',
  'folder_open',
  'text_snippet',
  'cloud',
  'request_quote',
  'cloud_download',
  'drive_file_rename_outline',
  'upload',
  'attachment',
  'download_for_offline',
  'newspaper',
  'create_new_folder',
  'downloading',
  'folder_shared',
  'cloud_done',
  'cloud_queue',
  'workspaces',
  'topic',
  'approval',
  'download_done',
  'cloud_off',
  'drive_file_move',
  'file_open',
  'drive_folder_upload',
  'file_download_done',
  'cloud_sync',
  'attach_email',
  'rule_folder',
  'folder_zip',
  'folder_copy',
  'cloud_circle',
  'snippet_folder',
  'difference',
  'file_download_off',
  'folder_delete',
  'drive_file_move_rtl',
  'folder_off',
  'format_overline',
  'play_arrow',
  'play_arrow',
  'play_circle_filled',
  'videocam',
  'play_circle',
  'mic',
  'volume_up',
  'pause',
  'play_circle_outline',
  'replay',
  'volume_off',
  'library_books',
  'skip_next',
  'fiber_manual_record',
  'speed',
  'stop',
  'movie',
  'skip_previous',
  'new_releases',
  'playlist_add',
  'loop',
  'equalizer',
  'fast_forward',
  'web',
  'playlist_add_check',
  'video_library',
  'library_add',
  'pause_circle',
  'mic_off',
  'stop_circle',
  'subscriptions',
  'volume_mute',
  'video_call',
  'repeat',
  'not_interested',
  'shuffle',
  'sort_by_alpha',
  'fast_rewind',
  'mic_none',
  'library_music',
  'volume_down',
  'videocam_off',
  'recent_actors',
  'web_asset',
  'library_add_check',
  'hearing',
  'queue_music',
  'pause_circle_filled',
  'subtitles',
  'fiber_new',
  'pause_circle_outline',
  'note',
  'av_timer',
  'album',
  'playlist_play',
  'queue',
  'games',
  'radio',
  'replay_circle_filled',
  'branding_watermark',
  'forward_10',
  'replay_10',
  'closed_caption',
  'video_settings',
  'high_quality',
  'featured_play_list',
  'playlist_add_check_circle',
  'control_camera',
  'playlist_remove',
  'add_to_queue',
  'slow_motion_video',
  'repeat_one',
  'airplay',
  'call_to_action',
  'snooze',
  'hd',
  'replay_30',
  'repeat_on',
  'closed_caption_off',
  'featured_video',
  'shuffle_on',
  'audio_file',
  'forward_30',
  '5g',
  'playlist_add_circle',
  'music_video',
  'queue_play_next',
  'replay_5',
  'interpreter_mode',
  'video_file',
  'art_track',
  'hearing_disabled',
  'forward_5',
  'explicit',
  '4k',
  'video_label',
  'fiber_smart_record',
  'repeat_one_on',
  'closed_caption_disabled',
  'remove_from_queue',
  'surround_sound',
  'play_disabled',
  'web_asset_off',
  'sd',
  'lyrics',
  'missed_video_call',
  '10k',
  'fiber_pin',
  'fiber_dvr',
  '4k_plus',
  '1k',
  '2k',
  '1k_plus',
  '8k',
  '9k_plus',
  '5k',
  '8k_plus',
  '3k',
  '5k_plus',
  '7k',
  '9k',
  '2k_plus',
  '7k_plus',
  '3k_plus',
  '6k',
  '6k_plus',
  'star',
  'star',
  'check_box',
  'check_box_outline_blank',
  'radio_button_unchecked',
  'radio_button_checked',
  'star_border',
  'toggle_on',
  'star_outline',
  'toggle_off',
  'star_half',
  'indeterminate_check_box',
  'star_purple500',
  'star_border_purple500',
  'warning',
  'warning',
  'error',
  'error_outline',
  'warning_amber',
  'notification_important',
  'add_alert',
  'auto_delete',
  'support_agent',
  'support_agent',
  'wifi',
  'account_tree',
  'sync',
  'priority_high',
  'event_available',
  'event_note',
  'confirmation_number',
  'sms',
  'live_tv',
  'ondemand_video',
  'drive_eta',
  'wifi_off',
  'event_busy',
  'do_not_disturb_on',
  'wc',
  'more',
  'power',
  'do_not_disturb',
  'sync_problem',
  'time_to_leave',
  'do_disturb_on',
  'vpn_lock',
  'running_with_errors',
  'folder_special',
  'enhanced_encryption',
  'do_disturb',
  'sms_failed',
  'network_check',
  'phone_callback',
  'adb',
  'phone_forwarded',
  'system_update',
  'power_off',
  'personal_video',
  'voice_chat',
  'vibration',
  'airline_seat_recline_normal',
  'do_disturb_alt',
  'do_not_disturb_alt',
  'sync_disabled',
  'tap_and_play',
  'no_encryption',
  'sd_card',
  'phone_missed',
  'airline_seat_recline_extra',
  'imagesearch_roller',
  'mms',
  'disc_full',
  'no_encryption_gmailerrorred',
  'sync_lock',
  'bluetooth_audio',
  'sd_card_alert',
  'sim_card_alert',
  'do_not_disturb_off',
  'airline_seat_individual_suite',
  'phone_paused',
  'do_disturb_off',
  'phone_locked',
  'network_locked',
  'airline_seat_flat',
  'tv_off',
  'phone_bluetooth_speaker',
  'airline_seat_flat_angled',
  'airline_seat_legroom_normal',
  'directions_off',
  'airline_seat_legroom_extra',
  'airline_seat_legroom_reduced',
  'video_chat',
  'attach_money',
  'attach_money',
  'edit_note',
  'format_list_bulleted',
  'mode_edit',
  'monetization_on',
  'attach_file',
  'post_add',
  'bar_chart',
  'checklist',
  'drag_handle',
  'show_chart',
  'insert_drive_file',
  'format_quote',
  'query_stats',
  'format_list_numbered',
  'table_chart',
  'border_color',
  'pie_chart',
  'notes',
  'format_bold',
  'checklist_rtl',
  'text_fields',
  'table_rows',
  'publish',
  'title',
  'insert_emoticon',
  'auto_graph',
  'insert_photo',
  'insert_chart_outlined',
  'draw',
  'mode',
  'mode_comment',
  'functions',
  'insert_link',
  'mode_edit_outline',
  'insert_invitation',
  'horizontal_rule',
  'format_align_left',
  'format_italic',
  'format_color_fill',
  'add_comment',
  'insert_chart',
  'linear_scale',
  'stacked_line_chart',
  'format_size',
  'insert_comment',
  'format_underlined',
  'money_off',
  'bubble_chart',
  'vertical_align_bottom',
  'height',
  'vertical_align_top',
  'schema',
  'format_align_center',
  'square',
  'format_paint',
  'area_chart',
  'format_color_text',
  'format_align_right',
  'scatter_plot',
  'format_list_numbered_rtl',
  'highlight',
  'format_align_justify',
  'data_object',
  'merge_type',
  'add_chart',
  'numbers',
  'format_shapes',
  'money_off_csred',
  'pie_chart_outline',
  'format_indent_increase',
  'short_text',
  'move_up',
  'strikethrough_s',
  'format_color_reset',
  'vertical_align_center',
  'align_horizontal_left',
  'hexagon',
  'rectangle',
  'move_down',
  'multiline_chart',
  'score',
  'border_all',
  'text_increase',
  'polyline',
  'format_indent_decrease',
  'format_clear',
  'space_bar',
  'format_line_spacing',
  'horizontal_distribute',
  'align_vertical_bottom',
  'candlestick_chart',
  'align_horizontal_center',
  'vertical_distribute',
  'align_horizontal_right',
  'format_strikethrough',
  'superscript',
  'data_array',
  'margin',
  'pentagon',
  'wrap_text',
  'align_vertical_top',
  'border_clear',
  'subscript',
  'align_vertical_center',
  'text_decrease',
  'border_style',
  'padding',
  'border_outer',
  'line_axis',
  'insert_page_break',
  'border_inner',
  'border_left',
  'border_bottom',
  'shape_line',
  'format_textdirection_l_to_r',
  'border_vertical',
  'border_horizontal',
  'format_textdirection_r_to_l',
  'border_top',
  'border_right',
  'type_specimen',
  'keyboard_arrow_down',
  'keyboard_arrow_down',
  'phone_iphone',
  'smartphone',
  'keyboard_arrow_right',
  'computer',
  'security',
  'desktop_windows',
  'smart_display',
  'keyboard_backspace',
  'phone_android',
  'keyboard_arrow_up',
  'keyboard_return',
  'keyboard_double_arrow_right',
  'laptop',
  'smart_toy',
  'keyboard_arrow_left',
  'memory',
  'headphones',
  'keyboard',
  'point_of_sale',
  'headset_mic',
  'tv',
  'keyboard_double_arrow_left',
  'keyboard_double_arrow_down',
  'mouse',
  'keyboard_voice',
  'developer_board',
  'router',
  'start',
  'videogame_asset',
  'keyboard_double_arrow_up',
  'cast_for_education',
  'device_hub',
  'headset',
  'laptop_mac',
  'cast',
  'watch',
  'tablet_mac',
  'devices_other',
  'desktop_mac',
  'keyboard_tab',
  'laptop_chromebook',
  'phonelink',
  'monitor',
  'speaker',
  'toys',
  'gamepad',
  'sim_card',
  'keyboard_alt',
  'connected_tv',
  'tablet_android',
  'cast_connected',
  'laptop_windows',
  'device_unknown',
  'browser_updated',
  'keyboard_hide',
  'scanner',
  'tablet',
  'speaker_group',
  'earbuds',
  'keyboard_capslock',
  'headset_off',
  'keyboard_command_key',
  'home_max',
  'headphones_battery',
  'power_input',
  'dock',
  'smart_screen',
  'browser_not_supported',
  'earbuds_battery',
  'phonelink_off',
  'home_mini',
  'adf_scanner',
  'developer_board_off',
  'videogame_asset_off',
  'keyboard_control_key',
  'watch_off',
  'keyboard_option_key',
  'light_mode',
  'light_mode',
  'restart_alt',
  'dark_mode',
  'task',
  'summarize',
  'password',
  'sell',
  'signal_cellular_alt',
  'devices',
  'settings_suggest',
  'quiz',
  'widgets',
  'storage',
  'credit_score',
  'thermostat',
  'battery_full',
  'gps_fixed',
  'price_check',
  'medication',
  'pin',
  'gpp_good',
  'price_change',
  'battery_charging_full',
  'fmd_good',
  'tungsten',
  'reviews',
  'air',
  'note_alt',
  'bluetooth',
  'graphic_eq',
  'monitor_heart',
  'dvr',
  'nightlight',
  'sports_score',
  'access_time',
  'water',
  'share_location',
  'gpp_maybe',
  'cable',
  'location_searching',
  'cameraswitch',
  'shortcut',
  'airplane_ticket',
  'wallpaper',
  'device_thermostat',
  'radar',
  'gpp_bad',
  'discount',
  'data_usage',
  'monitor_weight',
  'signal_wifi_4_bar',
  'developer_mode',
  'mode_night',
  'wifi_tethering',
  'battery_std',
  'bloodtype',
  'lan',
  'signal_cellular_4_bar',
  'fmd_bad',
  'flashlight_on',
  'splitscreen',
  'sim_card_download',
  'network_wifi',
  'access_time_filled',
  'airplanemode_active',
  'mobile_friendly',
  'usb',
  'send_to_mobile',
  'battery_alert',
  'lens_blur',
  'screen_search_desktop',
  'signal_wifi_statusbar_4_bar',
  'screen_rotation',
  'signal_wifi_statusbar_connected_no_internet_4',
  'gps_not_fixed',
  'system_security_update_good',
  'bluetooth_connected',
  'nfc',
  'remember_me',
  'battery_5_bar',
  'mode_standby',
  'pattern',
  'brightness_high',
  'battery_saver',
  'play_lesson',
  'storm',
  'data_saver_off',
  'data_saver_on',
  'brightness_medium',
  'bluetooth_searching',
  'grid_4x4',
  'brightness_low',
  'signal_wifi_0_bar',
  'mobiledata_off',
  'ad_units',
  'screenshot',
  'network_cell',
  'ssid_chart',
  'bluetooth_disabled',
  'battery_4_bar',
  'hdr_auto',
  'wifi_calling_3',
  'battery_0_bar',
  'security_update_good',
  'battery_unknown',
  'signal_wifi_off',
  'settings_system_daydream',
  'battery_6_bar',
  'signal_wifi_bad',
  'access_alarms',
  'battery_3_bar',
  'signal_wifi_connected_no_internet_4',
  'access_alarm',
  'aod',
  'flashlight_off',
  'signal_cellular_0_bar',
  'add_to_home_screen',
  'security_update',
  'medication_liquid',
  'gps_off',
  'battery_1_bar',
  'signal_wifi_statusbar_null',
  'sd_storage',
  'punch_clock',
  '4g_mobiledata',
  'grid_3x3',
  'reset_tv',
  'brightness_auto',
  'signal_cellular_connected_no_internet_4_bar',
  'wifi_lock',
  'do_not_disturb_on_total_silence',
  'battery_2_bar',
  'airplanemode_inactive',
  'nearby_error',
  'dataset',
  '1x_mobiledata',
  'screenshot_monitor',
  'security_update_warning',
  'signal_cellular_connected_no_internet_0_bar',
  'phishing',
  'screen_lock_portrait',
  'wifi_password',
  'system_security_update_warning',
  'system_security_update',
  'wifi_tethering_off',
  'edgesensor_high',
  'signal_cellular_nodata',
  '4g_plus_mobiledata',
  '30fps',
  'signal_cellular_off',
  'signal_wifi_4_bar_lock',
  'add_alarm',
  'lte_mobiledata',
  'network_wifi_1_bar',
  'location_disabled',
  'bluetooth_drive',
  'signal_cellular_null',
  'wifi_find',
  'mobile_off',
  'network_wifi_3_bar',
  'media_bluetooth_on',
  'rsvp',
  'edgesensor_low',
  'grid_goldenratio',
  '3g_mobiledata',
  'usb_off',
  'screen_lock_rotation',
  '60fps',
  'screen_lock_landscape',
  'lte_plus_mobiledata',
  'network_wifi_2_bar',
  'timer_10_select',
  'wifi_2_bar',
  'signal_cellular_alt_1_bar',
  'signal_cellular_no_sim',
  'wifi_tethering_error',
  'signal_cellular_alt_2_bar',
  'dataset_linked',
  'g_mobiledata',
  'wifi_1_bar',
  'wifi_channel',
  'timer_3_select',
  'h_mobiledata',
  'media_bluetooth_off',
  'e_mobiledata',
  'r_mobiledata',
  'h_plus_mobiledata',
  'hdr_on_select',
  'hdr_auto_select',
  'nearby_off',
  'hdr_off_select',
  'devices_fold',
  'fluorescent',
  'macro_off',
  'storefront',
  'storefront',
  'apartment',
  'fitness_center',
  'business_center',
  'spa',
  'meeting_room',
  'house',
  'corporate_fare',
  'ac_unit',
  'cottage',
  'family_restroom',
  'checkroom',
  'other_houses',
  'all_inclusive',
  'grass',
  'airport_shuttle',
  'child_care',
  'beach_access',
  'pool',
  'kitchen',
  'casino',
  'holiday_village',
  'room_service',
  'roofing',
  'room_preferences',
  'sports_bar',
  'free_breakfast',
  'bathtub',
  'escalator_warning',
  'child_friendly',
  'foundation',
  'food_bank',
  'gite',
  'villa',
  'night_shelter',
  'golf_course',
  'no_photography',
  'stairs',
  'microwave',
  'backpack',
  'elevator',
  'wash',
  'smoking_rooms',
  'cabin',
  'house_siding',
  'hot_tub',
  'countertops',
  'water_damage',
  'fire_extinguisher',
  'charging_station',
  'carpenter',
  'rv_hookup',
  'baby_changing_station',
  'soap',
  'smoke_free',
  'umbrella',
  'tapas',
  'do_not_touch',
  'rice_bowl',
  'tty',
  'balcony',
  'fence',
  'no_food',
  'houseboat',
  'bento',
  'wheelchair_pickup',
  'iron',
  'bungalow',
  'crib',
  'chalet',
  'do_not_step',
  'no_meeting_room',
  'escalator',
  'dry',
  'stroller',
  'no_drinks',
  'no_cell',
  'no_flash',
  'no_backpack',
  'no_stroller',
  'vaping_rooms',
  'desk',
  'vape_free',
  'manage_search',
  'manage_search',
  'feed',
  'chair',
  'bed',
  'podcasts',
  'coffee',
  'shower',
  'yard',
  'window',
  'light',
  'door_front',
  'garage',
  'dining',
  'flatware',
  'coffee_maker',
  'blender',
  'table_restaurant',
  'bedroom_parent',
  'camera_indoor',
  'bedroom_baby',
  'bathroom',
  'chair_alt',
  'door_sliding',
  'camera_outdoor',
  'door_back',
  'living',
  'doorbell',
  'bedroom_child',
  'table_bar',
  'sensor_door',
  'sensor_door',
  'electric_bolt',
  'energy_savings_leaf',
  'sensor_window',
  'solar_power',
  'auto_mode',
  'shield_moon',
  'wind_power',
  'oil_barrel',
  'sensor_occupied',
  'electric_meter',
  'heat_pump',
  'gas_meter',
  'propane_tank',
  'mode_fan_off',
  'roller_shades',
  'broadcast_on_personal',
  'propane',
  'blinds',
  'roller_shades_closed',
  'blinds_closed',
  'curtains',
  'vertical_shades',
  'vertical_shades_closed',
  'nest_cam_wired_stand',
  'broadcast_on_home',
  'curtains_closed',
] as const;

export type Icon =
| `abb/${keyof (typeof abbIconsMapper)['small']}`
| `mat/${(typeof materialIcons)[number]}`
| `mat-outlined/${(typeof materialIcons)[number]}`;
